import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InjectableAssetsCollection, PluginInjectorModule } from '@nexxe/plugin-injector';
import { BnCustomerInfoV2Component } from './bn-customer-info-v2.component';
import {EntryResolver} from './bn-customer-info-v2.resolver';
import{ CustomerInfoEntryService} from'./services/bn-customer-info-v2.service';
import { CdsModule } from '@nexxe/cds';
import {  CoreVendorsModule } from '@nexxe/core-vendors';
import { SharedModule } from "@nexxe/shared";
// Injectable Assets is a map of exposable assets [e.g. components, config, etc.], by a plugin.
// If a plugin is exposing a single component, the name could be empty to ease metadata composition.
// If a plugin is exposing multiple components, the default component could be empty but other components must specify a name.
// If a plugin is not exposing any assets, one could remove the assets collection entirely
const assets: InjectableAssetsCollection = [
  { type: 'component', name: '', asset: BnCustomerInfoV2Component, resolvers:{entry:EntryResolver } },
];

@NgModule({
  imports: [
    CommonModule,
    PluginInjectorModule,
    CoreVendorsModule,
    CdsModule,
    SharedModule
  ],
  exports: [
    BnCustomerInfoV2Component,
  ],
  declarations: [
    BnCustomerInfoV2Component,
  ],
  providers: [
    { provide: 'bn-customer-info-v2_assets', useValue: assets, multi: true }, EntryResolver, CustomerInfoEntryService
  ],
  entryComponents: [
    BnCustomerInfoV2Component,
  ],
})
export class BnCustomerInfoV2Module {
  constructor() { }
}
